export default __webpack_public_path__ + "static/media/rewards-blue.773058a2.svg";